// Application settings for working offline with a tax register (ПРРО); defined in the shared
// tax register package.

export type { TaxOfflineSettings } from 'tax-register-core';
export {
  API_MAX_OFFLINE_PACKAGE_DOCUMENTS,
  API_MAX_OFFLINE_SESSION_DURATION_MINUTES,
  DEFAULT_TAX_OFFLINE_SETTINGS,
  normalizeTaxOfflineSettings,
} from 'tax-register-core';
